<template>
  <div class="ButtonOptions__wrapper" @keyup.esc="opened = false">
    <div class="mask" v-if="opened" @click="opened = false"></div>
    <div class="ButtonOptions">
      <button class="moreOptions" @click="opened = !opened" title="More Options">
        <svg width="4" height="16" viewBox="0 0 4 16" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M2 6.5C2.82812 6.5 3.5 7.17188 3.5 8C3.5 8.82812 2.82812 9.5 2 9.5C1.17188 9.5 0.5 8.82812 0.5 8C0.5 7.17188 1.17188 6.5 2 6.5ZM0.5 3.25C0.5 4.07812 1.17188 4.75 2 4.75C2.82812 4.75 3.5 4.07812 3.5 3.25C3.5 2.42188 2.82812 1.75 2 1.75C1.17188 1.75 0.5 2.42188 0.5 3.25ZM0.5 12.75C0.5 13.5781 1.17188 14.25 2 14.25C2.82812 14.25 3.5 13.5781 3.5 12.75C3.5 11.9219 2.82812 11.25 2 11.25C1.17188 11.25 0.5 11.9219 0.5 12.75Z"
            fill="#69747C"
          />
        </svg>
      </button>
      <div v-if="opened" class="list" @click="opened = false">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ButtonOptions',
    data() {
      return {
        opened: false,
      };
    },
  };
</script>
<style scoped lang="scss">
  @import '../../assets/styles/variables';

  $sizePoint: 3px;

  .ButtonOptions__wrapper {
    .mask {
      z-index: 30;
      position: fixed;
      inset: 0;
      height: $deviceHeight;
      width: 100vw;
      background: black;
      opacity: 0.02;
    }
  }

  .ButtonOptions {
    display: grid;
    max-height: fit-content;
    z-index: 0;

    button.moreOptions {
      cursor: pointer;
      display: flex;
      flex-direction: column;
      gap: 2px;
      width: 1rem;
      height: 2rem;
      justify-content: center;
      align-items: center;
      span {
        width: $sizePoint;
        height: $sizePoint;
        background-color: black;
        border-radius: 2rem;
      }
    }
    .list {
      z-index: 40;
      position: absolute;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      gap: 0.5rem;
      height: fit-content;
      top: 2.5rem;
      right: 0.5rem;
      min-width: 180px;
      background: #ffffff;
      box-shadow: 0 10px 16px rgba(100, 90, 100, 0.12);
      border-radius: 12px;
      padding: 1rem 0;
      cursor: pointer;

      > button {
        text-align: start;
        border: none;
        padding: 4px 4px;
        background-color: $white;
        color: $neutral-black;
        width: 100%;
        padding: 12px 20px;
        font-size: 15px;
        cursor: pointer;
        transition: 0.3s ease-out;
        text-transform: capitalize;
        &:hover {
          background-color: $bg-light;
        }
      }
    }
  }
</style>
